export default __webpack_public_path__ + "static/20250217-c5b491f0da6c1b13890583cfc2061323.png";